export const text = '#3C4348';
export const hover = '#D05110';
export const coloredText = '#D05110';
export const whiteText = '#FFFFFF';
export const title = `"Century", Euclid Square, Arial, Helvetica, freesans, sans-serif `